/**
 * useBooks Hook
 * Хук для доступа к контексту книг
 */

import { useContext } from 'react';
import { BooksContext } from './BooksProvider';

export function useBooks() {
  const context = useContext(BooksContext);
  
  if (context === undefined) {
    throw new Error('useBooks must be used within a BooksProvider');
  }
  
  return context;
}
